export const baseurl = "https://instawork-backend.herokuapp.com/";
export const list = "list";
export const add = "add";
export const deleteUser = "delete";